if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        // Quantity and weight-based limits
        this.quantityInput = this.form.querySelector('[name="quantity"]');
        this.variantInput = this.form.querySelector('[name="id"]');

        // Validate on input change
        if (this.quantityInput) {
          this.quantityInput.addEventListener('input', () => {
            this._applyWeightLimitToQuantity();
          });
        }

        // Subscribe to variant changes so we can recalculate limits
        if (typeof subscribe === 'function') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            // event may come from a different section; ensure this form's variant was updated
            const currentVariantId = this.variantInput ? this.variantInput.value : null;
            const newVariantId = event && event.data && event.data.variant ? event.data.variant.id : null;
            if (!currentVariantId || !newVariantId) return;
            if (parseInt(currentVariantId, 10) === parseInt(newVariantId, 10)) {
              this._applyWeightLimitToQuantity();
            }
          });

          // Also re-check when the cart or quantity updates so remaining allowed values stay in sync
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
            this._applyWeightLimitToQuantity();
          });

          this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, () => {
            this._applyWeightLimitToQuantity();
          });
        }

        // Ensure limits applied on initial load
        this._applyWeightLimitToQuantity();
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // Prevent submission if quantity exceeds weight limit
        if (this._isOverWeightLimit && this._isOverWeightLimit()) {
          this.handleErrorMessage(`Quantity exceeds the maximum allowed by weight for this variant.`);
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        setTimeout(() => {
          $(`.atc-card-div #${evt.target.getAttribute("id")}`)[0].style.display = 'none'
          $(`#quantId-${evt.target.getAttribute("id")}`)[0].style.display = 'block'
        }, 1000)

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        // Pre-fetch: enforce weight-based limit even if there is no quantity input present
        try {
          const variantId = formData.get('id');
          const qtyValue = formData.get('quantity');
          const qty = qtyValue ? parseInt(qtyValue, 10) : 1;
          const limits = this._getWeightLimitsForVariant(variantId);
          const maxByWeight = this._computeMaxQtyByWeight(limits);

          const cartQty = await this._getCartQtyForVariant(variantId);
          const totalRequested = cartQty + qty;

          if (maxByWeight !== null && totalRequested > maxByWeight) {
            // revert loading UI
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');

            // show helpful message with context
            const remaining = Math.max(0, maxByWeight - cartQty);
            const msg = remaining <= 0
              ? `You already have ${cartQty} in cart and cannot add more due to max weight (${maxByWeight} kg).`
              : `You already have ${cartQty} in cart; you can add up to ${remaining} more (max total ${maxByWeight}).`;
            this.handleErrorMessage(msg || window.variantStrings?.maxQuantityExceededMessage || `Quantity exceeds the maximum allowed by weight for this variant.`);
            return;
          }
        } catch (e) {
          // non-fatal, continue
          console.error(e);
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            let alokUpdatesCustomInput = document.querySelector(`#CartDrawer2 input[data-quantity-variant-id="${formData.get('id')}"]`);
            console.log(alokUpdatesCustomInput , "alokUpdatesCustomInput")
            alokUpdatesCustomInput.setAttribute('data-cart-quantity', 1);
            alokUpdatesCustomInput.value = '1';
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
        if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
        if (this.quantityUpdateUnsubscriber) this.quantityUpdateUnsubscriber();
      }

      // Returns the selected variant id (string or number)
      _getSelectedVariantId() {
        return this.variantInput ? this.variantInput.value : null;
      }

      // Get weight limits object published in Liquid (window.variantKgLimits)
      _getWeightLimitsForVariant(variantId) {
        if (!window.variantKgLimits || !variantId) return null;
        // keys in variantKgLimits may be numbers or strings
        return window.variantKgLimits[variantId] || window.variantKgLimits[parseInt(variantId, 10)] || null;
      }

      // Returns how many of variantId are already in the cart (tries data attribute first, falls back to /cart.js)
      async _getCartQtyForVariant(variantId) {
        if (!variantId) return 0;

        // prefer data from the quantity input if available for the currently selected variant
        try {
          if (this.quantityInput && this.variantInput && parseInt(this.variantInput.value, 10) === parseInt(variantId, 10)) {
            const dq = this.quantityInput.getAttribute('data-cart-quantity');
            if (dq !== null && dq !== undefined && dq !== '') return parseInt(dq, 10) || 0;
          }
        } catch (e) {
          // ignore
        }

        // fallback to cart.js
        try {
          const cart = await fetch('/cart.js').then((r) => r.json());
          let qty = 0;
          if (cart && cart.items && Array.isArray(cart.items)) {
            cart.items.forEach((item) => {
              if (parseInt(item.variant_id, 10) === parseInt(variantId, 10)) qty += Number(item.quantity || 0);
            });
          }
          return qty;
        } catch (e) {
          console.error(e);
          return 0;
        }
      }

      // Compute max quantity allowed by weight limits (returns integer or null when unlimited)
      _computeMaxQtyByWeight(limits) {
        if (!limits) return null;
        const maxKg = Number(limits.maxKg || 0);
        const weightKg = Number(limits.weightKg || 0);
        if (!maxKg || !weightKg) return null;
        const maxQty = Math.floor(maxKg / weightKg);
        return maxQty > 0 ? maxQty : 0;
      }

      // Apply weight limit to current quantity input and form
      async _applyWeightLimitToQuantity() {
        if (!this.quantityInput) return;
        const variantId = this._getSelectedVariantId();
        const limits = this._getWeightLimitsForVariant(variantId);
        const weightMax = this._computeMaxQtyByWeight(limits);

        // cart quantity for this variant
        const cartQty = await this._getCartQtyForVariant(variantId);

        // Respect existing stock-based max (input.max may be null)
        const stockMax = this.quantityInput.hasAttribute('max') && this.quantityInput.getAttribute('max') !== '' ? parseInt(this.quantityInput.getAttribute('max'), 10) : null;

        // remaining allowed by weight (total allowed - already in cart)
        const remainingByWeight = weightMax === null ? null : Math.max(weightMax - cartQty, 0);

        // final max is the smaller of stockMax and remainingByWeight (if both present)
        let finalMax = null;
        if (stockMax === null && remainingByWeight === null) finalMax = null;
        else if (stockMax === null) finalMax = remainingByWeight;
        else if (remainingByWeight === null) finalMax = stockMax;
        else finalMax = Math.min(stockMax, remainingByWeight);

        // If both are null, there's no upper bound
        if (finalMax === null) {
          // remove any data attribute and don't alter input.max
          this.quantityInput.removeAttribute('data-max-by-weight');
          // update helper
          try {
            const weightNoteEl = (this.quantityInput.closest('quantity-input') || this.quantityInput.closest('.quantity')) ? document.getElementById(`Weight-Max-${(this.quantityInput.closest('quantity-input') || this.quantityInput.closest('.quantity')).getAttribute('data-section')}`) : this.form.querySelector('.quantity__weight-note');
            if (weightNoteEl) {
              weightNoteEl.textContent = '';
              weightNoteEl.setAttribute('hidden', '');
            }
          } catch (e) {}
          return;
        }

        // set a marker attribute so other code can read it (remaining allowed to add)
        this.quantityInput.setAttribute('data-max-by-weight', finalMax);
        // set input.max so native checks/controls respect it
        this.quantityInput.max = finalMax;

        // If there is no allowed quantity, disable submit
        if (finalMax <= 0) {
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.setAttribute('disabled', true);
          this.handleErrorMessage(window.variantStrings?.maxQuantityExceededMessage || `Maximum allowed quantity for this variant is 0 due to max weight limit.`);
        } else {
          // enable submit (if not otherwise disabled)
          if (!this.error) {
            this.submitButton.removeAttribute('aria-disabled');
            this.submitButton.removeAttribute('disabled');
          }

          // If current value exceeds finalMax, adjust and notify
          const currentQty = Number(this.quantityInput.value || 0);
          if (currentQty > finalMax) {
            this.quantityInput.value = finalMax;
            this.handleErrorMessage(`Maximum allowed quantity for this variant is ${finalMax} (weight limit).`);
          } else {
            // clear error if any
            this.handleErrorMessage();
          }
        }

        // Update the inline helper element (closest quantity-input has data-section)
        try {
          let weightNoteEl = null;
          const qtyContainer = this.quantityInput ? (this.quantityInput.closest('quantity-input') || this.quantityInput.closest('.quantity')) : null;
          const sectionId = qtyContainer ? qtyContainer.getAttribute('data-section') : null;
          if (sectionId) {
            weightNoteEl = document.getElementById(`Weight-Max-${sectionId}`);
          }
          if (!weightNoteEl) {
            weightNoteEl = this.form.querySelector('.quantity__weight-note');
          }

          if (weightNoteEl) {
            if (finalMax === null) {
              weightNoteEl.textContent = '';
              weightNoteEl.setAttribute('hidden', '');
            } else {
              // show remaining allowed and already in cart
              const totalAllowed = weightMax === null ? '∞' : weightMax;
              const msg = finalMax <= 0
                ? `No additional units allowed by weight (already in cart: ${cartQty}, max total: ${totalAllowed}).`
                : `Remaining by weight: ${finalMax} (already in cart: ${cartQty}, max total: ${totalAllowed})`;
              weightNoteEl.textContent = msg;
              weightNoteEl.removeAttribute('hidden');
            }
          }
        } catch (e) {
          // non-fatal
          console.error(e);
        }
      }

      // Check before submit if quantity is over the allowed weight limit
      _isOverWeightLimit() {
        if (!this.quantityInput) return false;
        const maxByWeight = this.quantityInput.hasAttribute('data-max-by-weight') ? parseInt(this.quantityInput.getAttribute('data-max-by-weight'), 10) : null;
        if (maxByWeight === null) return false;
        const qty = Number(this.quantityInput.value || 0);
        return qty > maxByWeight;
      }
    }
  );
}
